module.exports = __webpack_public_path__ + "img/178.89e66773.jpg";